import { render } from "./Changepw.vue?vue&type=template&id=839c6ba0&scoped=true"
import script from "./Changepw.vue?vue&type=script&lang=js"
export * from "./Changepw.vue?vue&type=script&lang=js"

import "./Changepw.vue?vue&type=style&index=0&id=839c6ba0&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-839c6ba0"]])

export default __exports__